import { FC, ReactNode } from 'react';
import ChartPlaceholder from './ChartPlaceholder';
import { CHART_PLACEHOLDER_CLASS_NAME } from './chartConfig';

interface ChartContentProps {
  isLoading: boolean;
  isEmpty: boolean;
  emptyMessage: string;
  children: ReactNode;
  placeholderClassName?: string;
}

const ChartContent: FC<ChartContentProps> = ({
  isLoading,
  isEmpty,
  emptyMessage,
  children,
  placeholderClassName = CHART_PLACEHOLDER_CLASS_NAME,
}) => {
  if (isLoading) {
    return (
      <ChartPlaceholder state="loading" className={placeholderClassName} />
    );
  }
  if (isEmpty) {
    return (
      <ChartPlaceholder
        state="empty"
        message={emptyMessage}
        className={placeholderClassName}
      />
    );
  }
  return <>{children}</>;
};

export default ChartContent;
